/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create a new transport stop
 * @export
 * @interface CreateTransportStop
 */
export interface CreateTransportStop {
    /**
     * 
     * @type {string}
     * @memberof CreateTransportStop
     */
    name: string;
}

/**
 * Check if a given object implements the CreateTransportStop interface.
 */
export function instanceOfCreateTransportStop(value: object): value is CreateTransportStop {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateTransportStopFromJSON(json: any): CreateTransportStop {
    return CreateTransportStopFromJSONTyped(json, false);
}

export function CreateTransportStopFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTransportStop {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CreateTransportStopToJSON(json: any): CreateTransportStop {
    return CreateTransportStopToJSONTyped(json, false);
}

export function CreateTransportStopToJSONTyped(value?: CreateTransportStop | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

